import { Box, Typography, keyframes } from '@mui/material';
import { useTranslate } from 'react-admin';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-4px);
  }
`;

interface TypingUser {
  userId: number;
  email?: string;
}

interface TypingIndicatorProps {
  users: TypingUser[];
}

export function TypingIndicator({ users }: TypingIndicatorProps) {
  const translate = useTranslate();

  if (users.length === 0) return null;

  const someone = translate('resources.chat.typing.someone');

  const getTypingText = () => {
    if (users.length === 1) {
      return translate('resources.chat.typing.one', { name: users[0].email || someone });
    }
    if (users.length === 2) {
      return translate('resources.chat.typing.two', {
        name1: users[0].email || someone,
        name2: users[1].email || someone.toLowerCase(),
      });
    }
    return translate('resources.chat.typing.many', { count: users.length });
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      px={2}
      py={1}
    >
      <Box display="flex" gap={0.5}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: 'text.secondary',
              animation: `${bounce} 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>
      <Typography variant="caption" color="textSecondary">
        {getTypingText()}
      </Typography>
    </Box>
  );
}
